<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <div id="recaptcha-container"></div>
      <login-card header-color="color" :showSocialLine="false" v-if="getAuthSettings && form.show">
        <h4 slot="title" class="title">Личный кабинет жильца</h4>
        <p slot="description" class="custom-danger" v-if="description">
          {{ description }}
        </p>

        <filter-locality
          v-show="!authSettingsReceivedByQueryParams"
          class="md-layout-item-field"
          slot="inputs"
          v-model="city"
        />
        <filter-thoroughfare
          v-show="!authSettingsReceivedByQueryParams"
          class="md-layout-item-field"
          slot="inputs"
          v-model="street"
          :localityId="city ? city.id : null"
          :disabled="!city"
        />
        <filter-premises
          v-show="!authSettingsReceivedByQueryParams"
          class="md-layout-item-field"
          slot="inputs"
          v-model="apartment"
          :thoroughfareId="street ? street.id : null"
          :disabled="!street"
        />

        <fade-transition slot="inputs" group :duration="600">
          <md-field
            class="md-form-group"
            v-if="displayLogin && filledFields || displayLogin && authSettingsReceivedByQueryParams"
            :key="1"
          >
            <md-icon>person_pin</md-icon>
            <label>Логин</label>
            <md-input
              v-model="form.login"
              required
              v-on:keyup.enter="submitHandler"
            >
            </md-input>
          </md-field>

          <md-field
            class="md-form-group"
            v-if="displayPass && filledFields || displayPass && authSettingsReceivedByQueryParams"
            :key="2"
            :class="[
              { 'md-error': errors.has('password') },
              { 'md-valid': !errors.has('password') && touched.password }
            ]"
          >
            <md-icon>lock_outline</md-icon>
            <label>Пароль</label>
            <md-input
              v-model="form.password"
              v-validate="modelValidations.password"
              data-vv-name="password"
              autocomplete="new-password"
              type="password"
              required
              v-on:keyup.enter="submitHandler"
            >
            </md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('password')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="!errors.has('password') && touched.password"
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>

          <md-field
            class="md-form-group"
            v-if="displayPersonalAccount && filledFields || displayPersonalAccount && authSettingsReceivedByQueryParams"
            :key="3"
            :class="[
              {
                'md-valid':
                  !errors.has('personalAccountNumber') &&
                  touched.personalAccountNumber
              },
              { 'md-error': errors.has('personalAccountNumber') }
            ]"
          >
            <md-icon>account_balance</md-icon>
            <label>Лицевой счет</label>
            <md-input
              v-model="form.personalAccountNumber"
              v-validate="modelValidations.personalAccountNumber"
              v-on:keyup.enter="submitHandler"
              data-vv-name="personalAccountNumber"
              required
            ></md-input>
          </md-field>

          <md-field
            class="md-form-group"
            v-if="displayApartment && filledFields || displayApartment && authSettingsReceivedByQueryParams"
            :key="4"
            :class="[
              {
                'md-valid':
                  !errors.has('apartmentNumber') && touched.apartmentNumber
              },
              { 'md-error': errors.has('apartmentNumber') }
            ]"
          >
            <md-icon>apartment</md-icon>
            <label>№ помещения</label>
            <md-input
              v-model="form.apartmentNumber"
              v-validate="modelValidations.apartmentNumber"
              v-on:keyup.enter="submitHandler"
              data-vv-name="apartmentNumber"
              required
            >
            </md-input>
          </md-field>

          <md-field
              v-if="filledFields && displayPhone || authSettingsReceivedByQueryParams && displayPhone"
              :key="5"
              class="md-form-group"
              :class="[
              { 'md-valid': !errors.has('phone') && touched.phone },
              { 'md-error': errors.has('phone') }
            ]"
          >
            <md-icon>phone</md-icon>
            <label>Телефон</label>
            <md-input
                v-model="form.phone"
                v-validate="modelValidations.phone"
                v-on:keyup.enter="submitHandler"
                data-vv-name="phone"
                required
            >
            </md-input>
          </md-field>

          <p
            :key="6"
            class="description"
            v-if="displayCredentialsNote"
          >
            {{ credentialsNote }}
          </p>
        </fade-transition>

        <md-button
          slot="footer"
          class="md-simple md-dense"
          :disabled="authSettingsReceivedByQueryParams ? false : !filledFields"
          @click.prevent="submitHandler"
        >
          Далее
        </md-button>
      </login-card>

      <login-card header-color="color" :showSocialLine="false" v-if="smsForm.show">
        <h4 slot="title" class="title">Авторизация</h4>
        <p slot="description" class="description">
          Введите 6-значный код, <br> который мы отправили на номер:
          <br>
          +{{ smsForm.phone }}
        </p>

        <div slot="inputs">
          <div class="code-inputs">
            <input
              v-for="i in 6"
              :key="`sms_input_${i}`"
              max="9"
              min="0"
              size="1"
              maxLength="1"
             :disabled="smsForm.disableCodeInputs"
             type="number"
             class="code-inputs__el"
             :class="{'code-inputs__el--fill': smsForm.smsCode[`p${i}`]}"
             pattern="[0-9]{1}"
             v-model="smsForm.smsCode[`p${i}`]"
             @keyup="codeInputHandlerOnUp"
             @keydown="e => codeInputHandlerOnDown(e, smsForm.smsCode[`p${i}`])"
             @focus="codeInputFocusHandler"
            />
          </div>
        </div>

        <div slot="footer" class="actions-footer">
          <md-button
              class="md-dense"
              @click.native.prevent="repeatSendMessage"
              :disabled="!smsForm.showRepeatButton"
          >
            Повторно запросить СМС {{ smsForm.showRepeatButton ? '' : `(${timeToRetry})` }}
          </md-button>
          <md-button
              class="md-simple md-dense"
              @click="resetAuth"
          >
            Отмена
          </md-button>
        </div>
      </login-card>

      <div v-if="loader" class="loader-wrapper">
        <circle-loader :diameter="40" />
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import firebase from 'firebase/app';
import 'firebase/auth';
import to from "await-to-js";
import { SlideYDownTransition, FadeTransition } from "vue2-transitions";
import { mapGetters } from "vuex";
import { LoginCard } from "@/components";
import {
  FilterThoroughfare,
  FilterLocality,
  FilterPremises,
} from "@/components/Fillters";
import CircleLoader from '@/components/Custom/CircleLoader';
import { FIREBASE_CONFIG } from '@/apps/auth/config';

export default {
  components: {
    LoginCard,
    CircleLoader,
    SlideYDownTransition,
    FadeTransition,
    FilterThoroughfare,
    FilterLocality,
    FilterPremises
  },
  data() {
    return {
      city: null,
      street: null,
      apartment: null,
      organization: null,
      description: null,
      authSettingsReceivedByQueryParams: false,
      firebaseInstance: null,
      firebaseAppVerifier : '',
      loader : false,
      smsForm: {
        show: false,
        time: moment(60 * 1000),
        phone: null,
        showRepeatButton: false,
        disableCodeInputs: false,
        smsCode: {
          p1: '',
          p2: '',
          p3: '',
          p4: '',
          p5: '',
          p6: '',
        },
      },
      form: {
        show: true,
        apartmentNumber: "",
        personalAccountNumber: "",
        login: "",
        password: "",
        firstName: "",
        phone: "+7",
        email: ""
      },
      touched: {
        apartmentNumber: false,
        personalAccountNumber: false,
        login: false,
        password: false,
        firstName: false,
        phone: false,
        email: false
      },
      modelValidations: {
        apartmentNumber: {
          required: true,
          min: 1,
          max: 5
        },
        personalAccountNumber: {
          required: true,
          min: 2,
          max: 20
        },
        phone: {
          required: true,
          min: 9,
          max: 20
        },
        password: {
          required: true,
          min: 4
        }
      }
    };
  },
  created() {
    if (!this.isNotUIAuth) {
      this.initFirebase()
      this.initReCaptcha()
    }
  },
  async mounted() {
    const lastAuthData = JSON.parse(localStorage.getItem('lastAuthData')) || null;

    if (this.isNotUIAuth) {
      this.form.show = false;
      this.loader = true;
      await this.submit();
    } else {
      if (this.orgIdFromQuery || this.orgGroupIdFromQuery || this.innFromQuery) {
        let payload;

        if (this.orgIdFromQuery) {
          payload = { manageOrganizationId: this.orgIdFromQuery };
        }

        if (this.orgGroupIdFromQuery) {
          payload = { manageorganizationgroupId: this.orgGroupIdFromQuery };
        }

        if (this.innFromQuery) {
          payload = { inn: this.innFromQuery };
        }

        await this.loadFields(payload);
        this.authSettingsReceivedByQueryParams = true;
      }

      if (!this.orgIdFromQuery && !this.orgGroupIdFromQuery && !this.innFromQuery) {
        if (lastAuthData) {
          this.city = lastAuthData.city;
          this.street = lastAuthData.street;
          this.apartment = lastAuthData.apartment;
        }
      }
    }
  },
  beforeDestroy() {
    if (this.firebaseInstance) {
      this.firebaseInstance.delete();
    }
  },
  computed: {
    ...mapGetters(["getAuthSettings"]),

    timeToRetry() {
      return this.smsForm.time.format('mm:ss');
    },

    smsCode() {
      const stack = this.smsForm.smsCode;
      return `${stack.p1}${stack.p2}${stack.p3}${stack.p4}${stack.p5}${stack.p6}`;
    },

    filledFields() {
      return !!this.city && !!this.street && !!this.apartment;
    },

    hasSMSVerification() {
      return this.getAuthSettings.smsVerification;
    },

    displayPhone() {
      return this.getAuthSettings.userContacts;
    },

    displayLogin() {
      return this.getAuthSettings.loginAccount;
    },

    displayPass() {
      return this.getAuthSettings.passwordAccount;
    },

    displayApartment() {
      return this.getAuthSettings.apartmentAccount;
    },

    displayPersonalAccount() {
      return this.getAuthSettings.personalAccount;
    },

    displayCredentialsNote() {
      return !!this.getAuthSettings.credentialsNote && this.filledFields && !this.description || this.authSettingsReceivedByQueryParams
    },

    credentialsNote() {
      return this.getAuthSettings.credentialsNote;
    },

    orgIdFromQuery() {
      return this.$route.query.org || null;
    },

    orgGroupIdFromQuery() {
      return this.$route.query.orggroup || null;
    },

    accountFromQuery() {
      return this.$route.query.account || null;
    },

    apartmentFromQuery() {
      return this.$route.query.apartment || null;
    },

    premiseIdFromQuery() {
      return this.$route.query.premise || null;
    },

    phoneFromQuery() {
      const { phone } = this.$route.query;
      return phone ? this.getPhone(phone) : null;
    },

    innFromQuery() {
      return this.$route.query.inn || null;
    },

    isNotUIAuth() {
      const hasMainQueries = this.apartmentFromQuery && this.accountFromQuery && this.phoneFromQuery;
      const hasOptionalQueries = this.premiseIdFromQuery || this.orgIdFromQuery || this.orgGroupIdFromQuery || this.innFromQuery;

      return hasMainQueries && hasOptionalQueries;
    }
  },
  methods: {
    /** Инит Firebase **/
    initFirebase() {
      this.firebaseInstance = firebase.initializeApp(FIREBASE_CONFIG);
    },

    /** Инит рекаптчи для Firebase **/
    initReCaptcha(){
      setTimeout(() => {
        this.firebaseAppVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
          'size': 'invisible',
          'expired-callback': function() {
            this.$notifySuccess('Обновите страницу');
          }
        });
      },1000)
    },

    /** Запросить смс в Firebase**/
    sendMessage(phoneNumber) {
      let phone = '+' + phoneNumber;
      this.$notifySuccess('Вам отправлено СМС соообщение с кодом');
      this.firebaseInstance
          .auth()
          .signInWithPhoneNumber(phone, this.firebaseAppVerifier)
          .then((confirmationResult) => {
            window.confirmationResult = confirmationResult;
          }).catch((data) => {
        if (data.code === 'auth/too-many-requests') {
          this.$notifyDanger('Вы сделали много попыток, повторите позже');
        } else {
          this.$notifyDanger('Ошибка при отправке СМС сообщения');
        }
        this.resetAuth();
      });
    },

    /** Отправить код из смс в Firebase **/
    confirmCode() {
      this.smsForm.disableCodeInputs = true;
      window.confirmationResult.confirm(this.smsCode).then((result) => {
        this.submit()
      }).catch(() => {
        this.smsForm.disableCodeInputs = false;
        this.$notifyDanger('Вы ввели неверный код');
      });
    },

    async loadFields(data) {
      const [err] = await to(this.$store.dispatch("AUTH_SETTINGS", data));
      if (err) {
        this.description = err.response.data.detail || "Ошибка! Попробуйте позже.";
      }
    },

    submitHandler() {
      this.$validator.validateAll().then(async isValid => {
        const authByQueryParams = this.authSettingsReceivedByQueryParams;

        if (authByQueryParams) {
          if (!isValid) return;
        } else {
          if (!isValid || !this.filledFields) return;
        }

        const phone = this.getPhone(this.form.phone);

        const payload = {
          apartmentNumber: this.form.apartmentNumber,
          personalAccountNumber: this.form.personalAccountNumber,
          login: this.form.login,
          password: this.form.password,
          firstName: this.form.firstName,
          username: this.displayPhone ? phone : '',
          email: this.form.email,
          add: !this.hasSMSVerification
        };

        if (authByQueryParams) {
          if (this.orgIdFromQuery) {
            payload.manageorganizationId = this.orgIdFromQuery;
          }

          if (this.innFromQuery) {
            payload.inn = this.innFromQuery;
          }

          if (this.orgGroupIdFromQuery) {
            payload.manageorganizationgroupId = this.orgGroupIdFromQuery;
          }

        } else {
          payload.premiseId = this.apartment.id;
        }

        const [err] = await to(this.$store.dispatch("AUTH_LOGIN", payload));

        if (!err) {
          if (this.hasSMSVerification) {
            this.startTimeToRetry();
            this.sendMessage(phone)
            this.form.show = false;
            this.smsForm.show = true;
            this.smsForm.phone = phone;
          } else {
            const userdata = Promise.all([
              this.$store.dispatch("GET_PERSONAL_ACCOUNT_INFO"),
              this.$store.dispatch("GET_PERSONAL_ACCOUNTS")
            ]);

            const [errAcc] = await to(userdata);

            if (!errAcc) {
              const lastAuthData = {
                city: this.city,
                street: this.street,
                apartment: this.apartment,
              }
              localStorage.setItem('lastAuthData', JSON.stringify(lastAuthData));
              const mobileWidth = 991;
              const routeName = window.innerWidth <= mobileWidth ? 'Main' : 'Home';
              this.$router.push({ name: routeName });
            } else {
              this.description = "Ошибка в получении данных пользователя";
            }
          }
        } else {
          this.description = err.response.data.detail || "Ошибка!";
        }

      });
    },

    async submit() {
      const authByQueryParams = this.authSettingsReceivedByQueryParams;
      const phone = this.getPhone(this.form.phone);

      const payload = {
        apartmentNumber: this.form.apartmentNumber,
        personalAccountNumber: this.form.personalAccountNumber,
        login: this.form.login,
        password: this.form.password,
        firstName: this.form.firstName,
        username: phone,
        email: this.form.email,
        add: true
      };

      if (this.isNotUIAuth) {
        payload.apartmentNumber = this.apartmentFromQuery;
        payload.personalAccountNumber = this.accountFromQuery;
        payload.username = this.phoneFromQuery;
        if (this.premiseIdFromQuery) {
          payload.premiseId = this.premiseIdFromQuery;
        }
        if (this.innFromQuery) {
          payload.inn = this.innFromQuery;
        }
        if (this.orgIdFromQuery) {
          payload.manageorganizationId = this.orgIdFromQuery;
        }
        if (this.orgGroupIdFromQuery) {
          payload.manageorganizationgroupId = this.orgGroupIdFromQuery;
        }
      } else {
        if (authByQueryParams) {
          if (this.orgIdFromQuery) {
            payload.manageorganizationId = this.orgIdFromQuery;
          }

          if (this.orgGroupIdFromQuery) {
            payload.manageorganizationgroupId = this.orgGroupIdFromQuery;
          }

        } else {
          payload.premiseId = this.apartment.id;
        }
      }

      const [err] = await to(this.$store.dispatch("AUTH_LOGIN", payload));

      if (!err) {
        const userdata = Promise.all([
          this.$store.dispatch("GET_PERSONAL_ACCOUNT_INFO"),
          this.$store.dispatch("GET_PERSONAL_ACCOUNTS")
        ]);

        const [errAcc] = await to(userdata);

        if (!errAcc) {
          const mobileWidth = 991;
          const routeName = window.innerWidth <= mobileWidth ? 'Main' : 'Home';
          this.$router.push({ name: routeName });
        } else {
          this.description = "Ошибка в получении данных пользователя";
        }
      } else {
        if (this.isNotUIAuth) {
          this.$notifyDanger(err.response.data.detail || 'Ошибка!');
          this.loader = false;
          this.form.show = true;
        } else {
          this.description = err.response.data.detail || "Ошибка!";
        }
      }
    },

    /** Повторно запросить смс из Firebase **/
    repeatSendMessage() {
      this.smsForm.time = moment(60 * 1000);
      this.startTimeToRetry();
      this.sendMessage(this.smsForm.phone);
    },

    /** Таймер блок состояния кнопки повтора запроса смс **/
    startTimeToRetry() {
      this.smsForm.showRepeatButton = false;
      const timer = setInterval(() => {
        this.smsForm.time = this.smsForm.time.clone().subtract(1, 'seconds')

        if(this.smsForm.time.diff(moment(0)) === 0){
          clearInterval(timer);
          this.smsForm.showRepeatButton = true;
        }

      }, 1000);
    },

    getPhone(phone) {
      let phoneNumber = phone;

      if (/^[+]{0,1}\d+$/.test(phone)) {
        switch (phoneNumber[0]) {
          case "8":
            phoneNumber = phoneNumber.replace("8", "7");
            break;
          case "+":
            phoneNumber = phoneNumber.substr(1);
            break;
          case "9":
            phoneNumber = "7" + phoneNumber;
            break;
        }
      }

      return phoneNumber;
    },

    codeInputFocusHandler(e) {
      if (e.target.previousSibling && e.target.previousSibling.value === '') {
        const relative = [ ...e.target.parentElement.children ];
        const firstEmptyIndex = relative.findIndex((el) => el.value === '')
        relative[firstEmptyIndex].focus();
      }
    },

    /** Выставить фокус инпута находящимся справа **/
    goNextInput(e) {
      if (e.target.nextSibling) {
        e.target.value = e.target._value
        e.target.nextSibling.focus()
      }
    },

    /** Выставить фокус инпута находящимся слева **/
    goPrevInput(e) {
      if (e.target.previousSibling) {
        e.target.value = e.target._value
        e.target.previousSibling.focus()
      }
    },

    /** keydown handler инпутов кода **/
    codeInputHandlerOnDown(e, oldCal) {
      e.target.value = e.target.value.substr(0, 0);
      if (e.keyCode === 8 && oldCal === '') {
        this.goPrevInput(e);
      }
    },

    /** keyup handler инпутов кода **/
    codeInputHandlerOnUp(e) {
      if (e.keyCode === 39) {
        this.goNextInput(e);
      } else if (e.keyCode === 37) {
        this.goPrevInput(e);
      } else if (e.target.value.length > 1) {
        e.target.value = ''
      } else if (e.target.nextSibling && e.target.value && e.target.nextSibling.value === '') {
        e.target.nextSibling.value = '';
        this.goNextInput(e);
      }
    },

    resetAuth() {
      this.city = null;
      this.street = null;
      this.apartment = null;
      this.organization = null;
      this.description = null;
      this.form = {
        show: true,
        apartmentNumber: "",
        personalAccountNumber: "",
        login: "",
        password: "",
        firstName: "",
        phone: "+7",
        email: ""
      }
      this.smsForm = {
        show: false,
        time: moment(60 * 1000),
        phone: null,
        showRepeatButton: false,
        disableCodeInputs: false,
        smsCode: {
          p1: '',
          p2: '',
          p3: '',
          p4: '',
          p5: '',
          p6: '',
        },
      };
      this.touched = {
        apartmentNumber: false,
        personalAccountNumber: false,
        login: false,
        password: false,
        firstName: false,
        phone: false,
        email: false
      };
    }
  },
  watch: {
    smsCode(val) {
      if (!val) return;

      if (val.length === 6) {
        this.confirmCode()
      }
    },
    apartment: {
      handler(value) {
        if (value) {
          this.loadFields({ premiseId: value.id });
        }
        this.$store.commit("AUTH_SETTINGS", {});
      }
    },
    "form.apartmentNumber"(val) {
      if (val) {
        this.touched.apartmentNumber = true;
        this.description = null;
      }
    },
    "form.personalAccountNumber"(val) {
      if (val) {
        this.touched.personalAccountNumber = true;
        this.description = null;
      }
    },
    "form.login"() {
      this.touched.login = true;
      this.description = null;
    },
    "form.password"() {
      this.touched.password = true;
      this.description = null;
    },
    "form.firstName"() {
      this.touched.firstName = true;
      this.description = null;
    },
    "form.username"() {
      this.touched.username = true;
      this.description = null;
    },
    "form.phone"() {
      this.touched.phone = true;
      this.description = null;
    },
    "form.email"() {
      this.touched.email = true;
      this.description = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.actions-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.code-inputs {
  text-align: center;
  margin-top: 15px;
  &__el {
    margin: 0 5px;
    text-align: center;
    line-height: 80px;
    font-size: 25px;
    border: none;
    border-bottom: solid 2px #ccc;
    outline: none;
    width: 35px;
    height: 35px;
    transition: all .2s ease-in-out;

    &::selection {
      background: transparent;
    }

    &:disabled {
      background-color: transparent;
      opacity: 0.3;
    }
  }
  &__el--fill {
    border-bottom-color: #4caf50;
  }
}
.custom-danger {
  color: red;
  text-align: center;
  font-weight: 400;
  font-size: 11px;
  opacity: 0.8;
  margin-bottom: 20px;
}
.loader-wrapper {
  display: flex;
  justify-content: center;
}
</style>
